// extracted by mini-css-extract-plugin
export var dropdownContainer = "_r2-0";
export var leftAlign = "_r2-4";
export var listItem = "_r2-2";
export var listItemWrapper = "_r2-1";
export var operationText = "_r2-3";